module.exports = __webpack_public_path__ + "static/tdlogo-d9355e3ee6cb586f91e9a1da70777c52.png";